import { Pipe, PipeTransform } from '@angular/core';
import { GridItem } from '../../models/grid-item.interface';
import { QueueViewColumn } from '../models/column.interface';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'appGridItemValueTransformer'
})
export class GridItemValueTransformerPipe implements PipeTransform {
  constructor (private _translateService: TranslateService) {
  }

  transform(row: GridItem, column: QueueViewColumn) {
    let returnValue = row[column.valueProperty];
    if (column.valueTransformer) {
      returnValue = column.valueTransformer(row[column.valueProperty]);
    }
    if (column.translatable && row[column.valueProperty] !== undefined) {
      returnValue = this._translateService.instant(returnValue);
    }
    return returnValue;
  }
}
